<template>
  <div class="c_table_wrap">
    <table>
      <colgroup>
        <col width="200px;">
        <col width="">
      </colgroup>
      <tr>
        <td class="c_t_title">
          작성일
        </td>
        <td class="">
          <div class="filter-select-div el-filter-date pt0 pb0">

                        <span class="filter-select-div el-filter-date">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                            class="el-date-common"
                            v-model="date"
                            prefix-icon=" "
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            placeholder="작성일"
                            @change="parentChange('date',date)"
                            clear-icon="none"
                            :picker-options="pickerOptions"
                        ></el-date-picker>
                        </span>
            <div class="input_error">{{ validation.firstError('date') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          제목
        </td>
        <td>
          <div>
            <el-input v-model="title" maxlength="40" @input="parentChange('title', title)"></el-input>
            <div class="input_error">{{ validation.firstError('title') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          이미지
        </td>
        <td>
          <div class="img_update">
            <div class="input_error board_error pt0 pb0 mb10">Pc에서 노출되는 이미지입니다.</br>크기 270 x 194 에 최적화 되어있습니다.</div>
            <div class="board_upload" @click="changeType('files')">
              <el-upload
                  class="avatar-uploader"
                  :auto-upload="false"
                  action=""
                  :show-file-list="false"
                  list-type="picture"
                  :file-list="files"
                  :on-change="onlyOnePhotoChange"
              >
                <img class="pc_img" v-if="hasFile('files')" :src="files[0].org_url">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="input_error">{{ validation.firstError('files') }}</div>
            </div>
          </div>
          <div class="img_update_mobile ml20">

            <div class="input_error board_error pt0 pb0 mb10">Mobile에서 노출되는 이미지입니다. <br> 크기 256 x 184 에 최적화 되어있습니다.
            </div>
            <div class="" @click="changeType('filesM')">
              <el-upload
                  class="avatar-uploader"
                  :auto-upload="false"
                  action=""
                  :show-file-list="false"
                  list-type="picture"
                  :file-list="filesM"
                  :on-change="onlyOnePhotoChange"
              >
                <img class="mobile_img_list" v-if="hasFile('filesM')" :src="filesM[0].org_url">
                <i v-else class="el-icon-plus avatar-uploader-icon board_img_mobile_list"></i>
              </el-upload>

              <div class="input_error">{{ validation.firstError('filesM') }}</div>
            </div>
          </div>
        </td>

      </tr>
      <tr>
        <td class="c_t_title">내용</td>
        <td>
          <div>
            <el-input type="textarea" id="content" v-model="content" rows="10"
                      @input="parentChange('content', content)"></el-input>
            <div class="input_error">{{ validation.firstError('content') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          메인 노출여부
        </td>
        <td>
          <el-radio-group v-model="mainDisplay" @change="parentChange('mainDisplay', mainDisplay)">
            <el-radio :label="1">사용</el-radio>
            <el-radio :label="0">미사용</el-radio>
          </el-radio-group>
        </td>
      </tr>
      <tr v-if="mainDisplay === 1">
        <td class="c_t_title">
          메인 이미지
        </td>
        <td>
          <div class="img_update">
            <div class="board_upload" @click="changeType('noticefiles')">
              <el-upload
                  class="avatar-uploader"
                  :auto-upload="false"
                  action=""
                  :show-file-list="false"
                  list-type="picture"
                  :file-list="noticefiles"
                  :on-change="onlyOnePhotoChange"
              >
                <img class="pc_main_img" v-if="hasFile('noticefiles')" :src="noticefiles[0].org_url">
                <i v-else class="el-icon-plus avatar-uploader-icon board_main_img"></i>
              </el-upload>
              <div class="input_error pt0 pb0">크기 351 x 223 에 최적화 되어있습니다.</div>
              <div class="input_error">{{ validation.firstError('noticefiles') }}</div>
            </div>
          </div>
          <div class="img_update_mobile ml20">

            <div class="board_upload" @click="changeType('noticefilesM')">
              <el-upload
                  class="avatar-uploader"
                  :auto-upload="false"
                  action=""
                  :show-file-list="false"
                  list-type="picture"
                  :file-list="noticefilesM"
                  :on-change="onlyOnePhotoChange"
              >
                <img class="mobile_main_img" v-if="hasFile('noticefilesM')" :src="noticefilesM[0].org_url">
                <i v-else class="el-icon-plus avatar-uploader-icon board_main_img_mobile"></i>
              </el-upload>
              <div class="input_error pt0 pb0">크기 650 x 318 에 최적화 되어있습니다.</div>
              <div class="input_error">{{ validation.firstError('noticefilesM') }}</div>
            </div>
          </div>
        </td>

      </tr>
    </table>


  </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import boardValidator from "@/mixins/validators/boardValidator";
import elFileMixins from "@/mixins/elFileMixins";
import imageOption from "@/mixins/imageOption";
import summernote from "@/mixins/summernote";

export default {
  name: "BoardWriteNewsLayout",
  mixins: [alertMixins, boardValidator, elFileMixins, imageOption, summernote],
  components: {},
  inject: {
    boardWriteSetData: {
      default: () => {
      }
    },
  },
  provide() {
    return {}
  },
  props: {
    boardData: {
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      pickerOptions: { //데이트피커 옵션
        disabledDate(time) {
          let nowDate = new Date();
          return time.getTime() > nowDate;
        },
      },
    }
  },
  created() {
  },
  mounted() {
    this.initSummernote('content', '내용', 'content');
    if (this.hasData()) {
      this.initSetData();
    }
    EventBus.$on('BoardWriteDefaultLayoutValidator', this.checkValidator);

  },
  beforeDestroy() {
    EventBus.$off('BoardWriteDefaultLayoutValidator')
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initSetData() {
      this.title = this.boardData.wr_subject;
      this.parentChange('title', this.title);
      this.date = this.boardData.wr_datetime;
      this.parentChange('date', this.date);
      this.parentChange('mainDisplay',this.mainDisplay);
      this.parentChange('imptDisplay',this.imptDisplay);

      if (!util.isEmpty(this.boardData.File.File)) {
        this.boardData.File.File[0].org_url = `${this.boardData.File.File[0].org_url}?${this.setImageOptions(270, 194, 'jpg')}`
        this.boardData.File.File[0].url = this.boardData.File.File[0].org_url;
        this.files = this.boardData.File.File
        this.parentChange('files', this.files);
      }

      if (!util.isEmpty(this.boardData.File.MobileFile)) {
        this.boardData.File.MobileFile[0].org_url = `${this.boardData.File.MobileFile[0].org_url}?${this.setImageOptions(256, 184, 'jpg')}`
        this.boardData.File.MobileFile[0].url = this.boardData.File.MobileFile[0].org_url;
        this.filesM = this.boardData.File.MobileFile
        this.parentChange('filesM', this.filesM);
      }
      if (!util.isEmpty(this.boardData.NoticeFile.File)) {
        this.mainDisplay = 1;
        this.boardData.NoticeFile.File[0].org_url = `${this.boardData.NoticeFile.File[0].org_url}?${this.setImageOptions(351, 223, 'jpg')}`
        this.boardData.NoticeFile.File[0].url = this.boardData.NoticeFile.File[0].org_url;
        this.noticefiles = this.boardData.NoticeFile.File
        this.parentChange('mainDisplay', this.mainDisplay);
        this.parentChange('noticefiles', this.noticefiles);
        this.parentChange('noticeTempFiles', this.noticefiles);
      }

      if (!util.isEmpty(this.boardData.NoticeFile.MobileFile)) {
        this.mainDisplay = 1;
        this.boardData.NoticeFile.MobileFile[0].org_url = `${this.boardData.NoticeFile.MobileFile[0].org_url}?${this.setImageOptions(650, 318, 'jpg')}`
        this.boardData.NoticeFile.MobileFile[0].url = this.boardData.NoticeFile.MobileFile[0].org_url;
        this.noticefilesM = this.boardData.NoticeFile.MobileFile
        this.parentChange('mainDisplay', this.mainDisplay);
        this.parentChange('noticefilesM', this.noticefilesM);
        this.parentChange('noticeTempFilesM', this.noticefilesM);
      }

      this.content = this.boardData.wr_content
      this.content = util.htmlDecode(this.content);
      this.parentChange('content', this.content);
      $('#content').summernote('code', this.content);


    },

    hasData() {
      return !util.isEmpty(this.boardData) && !util.isEmpty(this.boardData.wr_id);
    },
    hasFile(typeName) {
      if (this.hasOwnProperty(typeName) && !util.isEmpty(this[typeName]) && this[typeName][0].hasOwnProperty('org_url')) {
        return true;
      }
      return false;
    },
    checkValidator(dataArr) {
      console.log(dataArr)
      this.$validate(dataArr)
    },
    parentChange(key, value) {
      this.boardWriteSetData(key, value)

    },
  },
  watch: {
    'content': {
      deep: true,
      handler: function (val, oldVal) {
        this.parentChange('content', this.content)
      },
    }
  },
}
</script>

<style scoped>

</style>